import type {
    _OrderEventBaseFactoryParams} from "@@/shared/orders/order-events/events/_order-base.event";
import {
    _orderEventBaseFactory,
    _orderEventBaseZodObject,
} from "@@/shared/orders/order-events/events/_order-base.event";
import { signatureFactory } from "@@/shared/orders/order-events/signature-factory";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { generateWordSlug } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

const orderConfirmationMailSentZodSchema = _orderEventBaseZodObject.merge(
    z.object({
        type: z.literal("ORDER_CONFIRMATION_MAIL_SENT"),
        sentBy: userIdZodSchema.or(z.literal("SYSTEM")),
    }),
);
type OrderConfirmationMailSentEvent = z.infer<
    typeof orderConfirmationMailSentZodSchema
>;

// Factory params
type FactoryParams = _OrderEventBaseFactoryParams &
    Except<
        OrderConfirmationMailSentEvent,
        "type" | "_id" | "_type" | "_createdAt" | "signature"
    >;

type Params = Except<FactoryParams, "signature">;

const orderEventConfirmationMailSentFactory = (
    params: Params,
): OrderConfirmationMailSentEvent => ({
    ..._orderEventBaseFactory({
        orderId: params.orderId,
        orderGroupId: params.orderGroupId,
        _version: params._version,
        providerId: params.providerId,
        providerSlug: params.providerSlug,
        signature: signatureFactory(
            params.orderId,
            "ORDER_CONFIRMATION_MAIL_SENT",
            [generateWordSlug()],
        ),
    }),

    type: "ORDER_CONFIRMATION_MAIL_SENT",
    sentBy: params.sentBy,
});

export {
    orderConfirmationMailSentZodSchema,
    orderEventConfirmationMailSentFactory,
};
export type { OrderConfirmationMailSentEvent };
